import { render, staticRenderFns } from "./AskChatForm.vue?vue&type=template&id=f21278e4&scoped=true&"
import script from "./AskChatForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./AskChatForm.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AskChatForm.vue?vue&type=style&index=0&id=f21278e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21278e4",
  null
  
)

export default component.exports